import React, { useEffect, useMemo, useState } from 'react'
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { deleteCategoryApi, deleteEmailTemplate, deletePackageApi, deleteShippingApi, getAllUsersApi, getCategoriesApi, getEmailTemplate, getPackageEnquiryApi, getPackageSizeApi, getShippingChargeApi, sendMailUserApi, updateUserStatusApi } from '../../apiHelper/authService';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setSelectedCategory, setSelectedEmailTemplate, setSelectedFollowUp, setSelectedPackage, setSelectedShippingCharge, setSelectedUser } from '../../redux/authModalSlice';
const CustomersTable = () => {
  // const [activeTab, setActiveTab] = useState("ALL");
  // const tabOptions = [
  //     { label: "ALL", value: "ALL" },
  //     { label: "PENDING", value: "PENDING" },
  //     { label: "WORK IN PROGRESS", value: "WORK_IN_PROGRESS" },
  //     { label: "RESOLVED", value: "RESOLVED" },
  //     { label: "CLOSED", value: "CLOSED" },
  // ];

  const [customerLoading, setCustomersLoading] = useState(false)
  const [getLoading, setGetLoading] = useState(false)

  const [sendingEmail, setSendingEmail] = useState(false)
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [suspendForm, setSuspendForm] = useState({ remarks: "", email_template_id: "" });
  const [sendMailForm, setSendMailForm] = useState({ subject: "", message: "" });
  const [selectedUserMail, setSelectedUserMail] = useState("");


  const [loadingStatus, setLoadingStatus] = useState(false);





  const [activeTab, setActiveTab] = useState("PLACED");
  const tabOptions = [
    { label: "PLACED", value: "PLACED" },
    { label: "RECEIVED", value: "RECEIVED" },
    { label: "SHIPPED", value: "SHIPPED" },
    { label: "REACHED TO LOCAL PARTNER", value: "REACHED_TO_LOCAL_PARTNER" },
    { label: "DELIVERED", value: "DELIVERED" },
    { label: "HOLD", value: "HOLD" },
    { label: "CANCELLED", value: "CANCELLED" },


  ];

  const [emailTemplates, setEmailTemplates] = useState();


  const tabs = ["ALL", "PENDING", "WORK IN PROGRESS", "RESOLVED", "CLOSED"];
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedShippingId, setSelectedShippingId] = useState(null);
  const navigate = useNavigate()


  const dispatch = useDispatch()

  const [activeStatus, setActiveStatus] = useState("ACTIVE");

  const [itemsPerPage] = useState(10);


  const { user } = useSelector((state) => state.authModal);
  // const [categories, setCategories] = useState();
  // const [shippingCharges, setShippingCharges] = useState();
  const [enquiryData, setEnquiryData] = useState()



  const fromCountry = user?.from;
  const toCountry = user?.to;







  // console.log("UserData:", fromCountry)

  const [loading, setLoading] = useState(false);
  // useEffect(() => {
  //     const table = $('#dataTable').DataTable({
  //         pageLength: 10,
  //     });
  //     return () => {
  //         table.destroy(true);
  //     };
  // }, []);




  const getPackageEnquiry = async () => {
    setLoading(true);
    setCustomersLoading(true)

    setGetLoading(true)



    // const toastId = toast.loading("Fetching Email Templates...");

    try {
      const data = await getAllUsersApi({ status: activeStatus });
      // setCategories(data);
      // setShippingCharges(data)
      // setCustomersLoading(false);
      setEnquiryData(data)
      // toast.success("Email Templates fetched successfully!", { id: toastId });
    } catch (err) {
      console.error("Fetch Error:", err);

      // toast.error(
      //     err?.message || "Something went wrong while fetching email templates.",
      //     { id: toastId }
      // );
    } finally {
      setCustomersLoading(false);
      setGetLoading(false)
      setLoading(false);
    }
  };


  useEffect(() => {

    getPackageEnquiry()


  }, [activeStatus])



  const getEmailTemplates = async () => {
    setLoading(true);
    setCustomersLoading(true);



    try {
      const data = await getEmailTemplate();
      // setCategories(data);
      setEmailTemplates(data?.emailTemplates)
      setCustomersLoading(false);
      // toast.success("Email Templates fetched successfully!", { id: toastId });
    } catch (err) {
      console.error("Fetch Error:", err);

      // toast.error(
      //     err?.message || "Something went wrong while fetching email templates.",
      //     { id: toastId }
      // );
    } finally {
      setCustomersLoading(false);
      setLoading(false);
    }
  };


  useEffect(() => {

    getEmailTemplates()


  }, [])

  console.log(emailTemplates)



  const [searchQuery, setSearchQuery] = useState("");


  const filteredData = enquiryData?.filter((item) =>
    Object.values(item).some((val) =>
      String(val).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );


  const totalItems = filteredData?.length || 0;
  const itemsPerPageSafe = itemsPerPage || 1;
  const totalPages = Math.ceil(totalItems / itemsPerPageSafe);
  const startIdx = (currentPage - 1) * itemsPerPage;
  // const currentItems = enquiryData?.slice(startIdx, startIdx + itemsPerPage);
  const currentItems = Array.isArray(filteredData)
    ? filteredData.slice(startIdx, startIdx + itemsPerPage)
    : [];


  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleConfirmDelete = async () => {
    if (!selectedShippingId) return;

    setLoading(true);
    setCustomersLoading(true);


    // const toastId = toast.loading("Deleting...");

    try {
      const data = await deleteShippingApi(selectedShippingId);
      // getPackageSizes()
      // getShipCharges()

      // toast.success("Delted", { id: toastId });
      const modalEl = document.getElementById('exampleModalEdit');
      const modalBackdrop = document.querySelector('.modal-backdrop');

      modalEl.classList.remove('show');
      modalEl.style.display = 'none';
      modalEl.setAttribute('aria-hidden', 'true');

      if (modalBackdrop) modalBackdrop.remove();
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    } catch (err) {
      console.error("Fetch Error:", err);

      toast.error(
        err || "Something went wrong.",
        // { id: toastId }
      );
    } finally {
      setLoading(false);
      // setSelectedCategoryId(null)
    }

  }

  const handleChangeStatus = async (userId, status, payload = {}) => {
    setLoading(true);

    try {
      await updateUserStatusApi(userId, {
        status,
        remarks: payload.remarks || "",
        email_template_id: payload.email_template_id || "",
      });

      setActiveStatus(status); // update local state
      toast.success("Status Updated")
    } catch (err) {
      // console.error("Error:", err);
      toast.error(err)
    } finally {
      setLoading(false);
    }
  };


  const handleSendMailToUser = async (payload = {}) => {
    setSendingEmail(true);

    try {
      await sendMailUserApi(payload);


      toast.success("Mail has been send to user.")
    } catch (err) {
      // console.error("Error:", err);
      toast.error(err)
    } finally {
      setSendingEmail(false);
    }
  };






  // function stripHtml(html) {
  //     const div = document.createElement('div');
  //     div.innerHTML = html;
  //     return div.textContent || div.innerText || '';
  // }

  // const handleConfirmDelete = async () => {
  //     if (!selectedMailId) return;

  //     setLoading(true);



  //     const toastId = toast.loading("Deleting...");

  //     try {
  //         const data = await deleteEmailTemplate({ id: selectedMailId });
  //         getEmailTemplates()


  //         toast.success("Delted", { id: toastId });
  //         const modalEl = document.getElementById('exampleModalEdit');
  //         const modalBackdrop = document.querySelector('.modal-backdrop');

  //         modalEl.classList.remove('show');
  //         modalEl.style.display = 'none';
  //         modalEl.setAttribute('aria-hidden', 'true');

  //         if (modalBackdrop) modalBackdrop.remove();
  //         document.body.classList.remove('modal-open');
  //         document.body.style.overflow = '';
  //         document.body.style.paddingRight = '';
  //     } catch (err) {
  //         console.error("Fetch Error:", err);

  //         toast.error(
  //             err?.message || "Something went wrong while fetching categories.",
  //             { id: toastId }
  //         );
  //     } finally {
  //         setLoading(false);

  //     }

  // }

  function getTotalVal(taxPercent, internationCharge, localCharge, humanCharge) {
    const subtotal = internationCharge + localCharge + humanCharge;
    const taxAmount = (subtotal * taxPercent) / 100;
    const total = subtotal + taxAmount;
    return total.toFixed(2);
  }

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }








  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };


  const sortedItems = useMemo(() => {
    if (!sortConfig.key) return currentItems;
    const sorted = [...currentItems].sort((a, b) => {
      const valA = a[sortConfig.key]?.toString().toLowerCase();
      const valB = b[sortConfig.key]?.toString().toLowerCase();

      if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
      if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
    return sorted;
  }, [currentItems, sortConfig]);

  const getSortIcon = (key) => {
    const baseClass = "transition-all duration-300 ease-in-out";

    if (sortConfig.key !== key) {
      // Neutral icon when column is not sorted
      return <Icon icon="lucide:chevrons-up-down" className={`${baseClass} text-muted`} />;
    }

    return sortConfig.direction === "asc" ? (
      <Icon icon="lucide:chevron-up" className={`${baseClass} text-muted`} />
    ) : (
      <Icon icon="lucide:chevron-down" className={`${baseClass} text-muted`} />
    );
  };

  const generatePagination = (currentPage, totalPages) => {
    const delta = 2; // neighbors count
    const range = [];

    for (let i = Math.max(1, currentPage - delta); i <= Math.min(totalPages, currentPage + delta); i++) {
      range.push(i);
    }

    if (range[0] > 2) {
      range.unshift("...");
    }
    if (range[0] !== 1) {
      range.unshift(1);
    }

    if (range[range.length - 1] < totalPages - 1) {
      range.push("...");
    }
    if (range[range.length - 1] !== totalPages) {
      range.push(totalPages);
    }

    return range;
  };



  return (
    <>
      {/* <div className="col-xxl-12 mb-16">
                <div className="card p-0 overflow-hidden position-relative radius-12 h-100">

                    <div className="card-body px-14">
                        <ul
                            className="nav bordered-tab border border-top-0 border-start-0 border-end-0 d-inline-flex nav-pills mb-8 w-100"
                            role="tablist"
                        >
                            {tabOptions.map((tab) => (
                                <li className="nav-item" key={tab.value} role="presentation">
                                    <button
                                        className={`nav-link px-16 py-10 ${activeTab === tab.value ? "active" : ""}`}
                                        type="button"
                                        role="tab"
                                        onClick={() => setActiveTab(tab.value)}
                                    >
                                        {tab.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div> */}
      <div className="card basic-data-table">
        <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
          <div className="d-flex align-items-center flex-wrap gap-3">
            <form className="navbar-search">
              <input
                type="text"
                className="bg-base h-40-px w-auto"
                name="search"
                placeholder="Search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <Icon icon="ion:search-outline" className="icon" />
            </form>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              flexWrap: "wrap",
            }}
          >
            <div className=" overflow-hidden position-relative ">
              <div className="card-body " style={{ padding: "0px" }}>
                <ul
                  className="nav focus-tab nav-pills"
                  id="pills-tab-two"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link fw-semibold text-primary-light radius-4 px-16 py-10 ${activeStatus === "ACTIVE" ? "active" : ""
                        }`}
                      type="button"
                      onClick={() => setActiveStatus("ACTIVE")}
                    >
                      ACTIVE
                    </button>
                  </li>

                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link fw-semibold text-primary-light radius-4 px-16 py-10 ${activeStatus === "SUSPEND" ? "active" : ""
                        }`}
                      type="button"
                      onClick={() => setActiveStatus("SUSPEND")}
                    >
                      SUSPENDED
                    </button>
                  </li>
                </ul>
              </div>
            </div>

            <Link
              to={"/create-users"}
              className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
            >
              <Icon
                icon="ic:baseline-plus"
                className="icon text-xl line-height-1"
              />
              Add New Customers
            </Link>
          </div>
        </div>
        <div className="card-body">
          <div className="table-responsive" style={{ minHeight: "50vh" }}>
            <table className="table vertical-striped-table mb-0">
              <thead>
                <tr>
                  <th scope="col">No</th>
                  {/* <th scope="col">	User Id</th> */}
                  <th
                    scope="col"
                    onClick={() => handleSort("user_id")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      User ID 
                      {/* {getSortIcon("user_id")} */}
                    </div>
                  </th>
                  <th
                    scope="col"
                    onClick={() => handleSort("fullname")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      Full Name 
                      {/* {getSortIcon("fullname")} */}
                    </div>
                  </th>

                  <th
                    onClick={() => handleSort("mobilenumber")}
                    style={{ cursor: "pointer" }}
                    scope="col"
                  >
                    <div className="d-flex align-items-center gap-2">
                      User Mobile 
                      {/* {getSortIcon("mobilenumber")} */}
                    </div>
                  </th>
                  <th
                    onClick={() => handleSort("email")}
                    style={{ cursor: "pointer" }}
                    scope="col"
                  >
                    {" "}
                    <div className="d-flex align-items-center gap-2">
                      User Email 
                      {/* {getSortIcon("email")} */}
                    </div>
                  </th>

                  <th scope="col"> Sign in type</th>

                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                {getLoading ? (
                  <tr>
                    <td colSpan="7" className="text-center py-20">
                      <div
                        className="spinner-border"
                        role="status"
                        style={{
                          color: "#243E85",
                          width: "2rem",
                          height: "2rem",
                          borderWidth: "0.3em",
                        }}
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </td>
                  </tr>
                ) : currentItems?.length > 0 ? (
                  sortedItems?.map((enquiry, idx) => (
                    <tr key={enquiry.id}>
                      <td>
                        <div className="d-flex align-items-center">
                          <h6 className="text-md mb-0 fw-medium flex-grow-1">
                            {(currentPage - 1) * itemsPerPage + idx + 1}
                          </h6>
                        </div>
                      </td>

                      <td>
                        <div className="d-flex align-items-center">
                          <h6 className="text-md mb-0 fw-medium flex-grow-1 ">
                            {enquiry?.user_id}
                          </h6>
                        </div>
                      </td>

                      <td>
                        <div className="d-flex align-items-center">
                          <h6 className="text-md mb-0 fw-medium flex-grow-1 ">
                            {enquiry?.fullname || "-"}
                          </h6>
                        </div>
                      </td>

                      <td>
                        <div className="d-flex align-items-center">
                          <h6 className="text-md mb-0 fw-medium flex-grow-1 ">
                            {enquiry?.country_code}-{enquiry?.mobilenumber}
                          </h6>
                        </div>
                      </td>

                      <td>
                        <div className="d-flex align-items-center">
                          <h6 className="text-md mb-0 fw-medium flex-grow-1 ">
                            {enquiry.email}
                          </h6>
                        </div>
                      </td>
 <td>
                              {enquiry?.signup_type === "GOOGLE" ? (
                                <span className="bg-warning-focus text-warning-main px-16 py-4 rounded-pill fw-medium text-sm">
                                  GOOGLE
                                </span>
                              ) : (
                                <span className="bg-success-focus text-success-main px-16 py-4 rounded-pill fw-medium text-sm">
                                  NORMAL
                                </span>
                              )}
                            </td>
                      <td>
                        <div className="d-flex align-items-center justify-content-start gap-2">
                          <div className="dropdown">
                            <button
                              className="btn bg-success-100 border-success-100 text-success-600 px-18 py-11 d-flex align-items-center justify-content-center rounded-circle"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              title="Update Status"
                            >
                              <Icon icon="lucide:refresh-ccw" />
                            </button>

                            <ul className="dropdown-menu">
                              {activeStatus === "ACTIVE" ? (
                                <li>
                                  <button
                                    className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                    data-bs-toggle="modal"
                                    data-bs-target="#suspendReason"
                                    onClick={() => setSelectedUserId(enquiry?.id)}
                                  >
                                    Suspend
                                  </button>
                                </li>
                              ) : (
                                <li>
                                  <button
                                    className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                    onClick={() => handleChangeStatus(enquiry?.id, "ACTIVE")}
                                  >
                                    Activate
                                  </button>
                                </li>
                              )}
                            </ul>
                          </div>

                          <Link
                            to={'/edit-users'}
                            onClick={() => dispatch(setSelectedUser(enquiry))}
                            className="w-32-px h-32-px bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                            title="Edit User"
                          >
                            <Icon icon="lucide:edit" />
                          </Link>

                          <span
                            data-bs-toggle="modal"
                            data-bs-target="#sendMail"
                            onClick={() => setSelectedUserMail(enquiry?.email)}
                            style={{ cursor: "pointer" }}
                            className="w-32-px h-32-px bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                            title="Send Email"
                          >
                            <Icon icon="lucide:mail" />
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center py-16 text-muted">
                      No User found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {filteredData?.length > itemsPerPage && (
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-24">
              <span>
                Showing {startIdx + 1} to{" "}
                {Math.min(startIdx + itemsPerPage, filteredData?.length)} of{" "}
                {filteredData?.length} entries
              </span>
              <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                <li className="page-item">
                  <button
                    className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                    onClick={() => goToPage(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    <Icon icon="ep:d-arrow-left" className="text-xl" />
                  </button>
                </li>

                {/* {[...Array(totalPages)].map((_, index) => (
                  <li className="page-item" key={index}>
                    <button
                      className={`page-link ${currentPage === index + 1
                          ? "bg-primary-600 text-white"
                          : "bg-primary-50 text-secondary-light"
                        } fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px`}
                      onClick={() => goToPage(index + 1)}
                    >
                      {index + 1}
                    </button>
                  </li>
                ))} */}
                {generatePagination(currentPage, totalPages).map((page, index) => (
                  <li className="page-item" key={index}>
                    {page === "..." ? (
                      <span className="page-link bg-transparent border-0 text-secondary-light">...</span>
                    ) : (
                      <button
                        className={`page-link ${currentPage === page
                            ? "bg-primary-600 text-white"
                            : "bg-primary-50 text-secondary-light"
                          } fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px`}
                        onClick={() => goToPage(page)}
                      >
                        {page}
                      </button>
                    )}
                  </li>
                ))}
                <li className="page-item">
                  <button
                    className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                    onClick={() => goToPage(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    <Icon icon="ep:d-arrow-right" className="text-xl" />
                  </button>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>

      <div
        className="modal fade"
        id="suspendReason"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
          <div className="modal-content radius-16 bg-base">
            <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Add Remarks for Suspension
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body p-24">
              <form
                onSubmit={async (e) => {
                  e.preventDefault();

                  // Optional validation

                  await handleChangeStatus(selectedUserId, "SUSPEND", {
                    remarks: suspendForm.remarks,
                    email_template_id: suspendForm.email_template_id,
                  });

                  // Optionally close modal
                  // const modal = bootstrap.Modal.getInstance(document.getElementById('suspendReason'));
                  // modal?.hide();

                  setSuspendForm({
                    remarks: "",
                    email_template_id: "",
                  });

                  const modalEl = document.getElementById("suspendReason");
                  const modalBackdrop =
                    document.querySelector(".modal-backdrop");

                  modalEl.classList.remove("show");
                  modalEl.style.display = "none";
                  modalEl.setAttribute("aria-hidden", "true");

                  if (modalBackdrop) modalBackdrop.remove();
                  document.body.classList.remove("modal-open");
                  document.body.style.overflow = "";
                  document.body.style.paddingRight = "";
                }}
              >
                <div className="row">
                  {/* Remarks Field */}
                  <div className="col-12 col-md-12 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Remark
                    </label>
                    <textarea
                      required
                      className="form-control radius-8"
                      placeholder="Remarks"
                      value={suspendForm.remarks}
                      onChange={(e) =>
                        setSuspendForm({
                          ...suspendForm,
                          remarks: e.target.value,
                        })
                      }
                      rows={4}
                    />
                  </div>

                  {/* Email Template Select */}
                  <div className="col-12 col-md-12 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Select Email Template
                    </label>
                    <select
                      required
                      className="form-control radius-8"
                      value={suspendForm.email_template_id}
                      onChange={(e) =>
                        setSuspendForm({
                          ...suspendForm,
                          email_template_id: e.target.value,
                        })
                      }
                    >
                      <option value="">-- Select Email Template --</option>
                      {emailTemplates?.map((template) => (
                        <option key={template.id} value={template.id}>
                          {template.title}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Submit Button */}
                  <div className="d-flex align-items-center justify-content-start gap-3 mt-12">
                    <button
                      type="submit"
                      className="btn btn-primary border border-primary-600 text-md px-48 py-12 radius-8"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="sendMail"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
          <div className="modal-content radius-16 bg-base">
            <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Send mail to user
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body p-24">
              <form
                onSubmit={async (e) => {
                  e.preventDefault();

                  // Optional validation

                  await handleSendMailToUser({
                    ...sendMailForm,
                    email: selectedUserMail,
                  });

                  // Optionally close modal
                  // const modal = bootstrap.Modal.getInstance(document.getElementById('suspendReason'));
                  // modal?.hide();

                  setSendMailForm({
                    subject: "",
                    message: "",
                  });

                  const modalEl = document.getElementById("sendMail");
                  const modalBackdrop =
                    document.querySelector(".modal-backdrop");

                  modalEl.classList.remove("show");
                  modalEl.style.display = "none";
                  modalEl.setAttribute("aria-hidden", "true");

                  if (modalBackdrop) modalBackdrop.remove();
                  document.body.classList.remove("modal-open");
                  document.body.style.overflow = "";
                  document.body.style.paddingRight = "";
                }}
              >
                <div className="row">
                  {/* Remarks Field */}

                  <div className="col-12 col-md-12 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Subject
                    </label>
                    <input
                      required
                      className="form-control radius-8"
                      placeholder="Enter mail subject"
                      value={sendMailForm.subject}
                      onChange={(e) =>
                        setSendMailForm({
                          ...sendMailForm,
                          subject: e.target.value,
                        })
                      }
                      rows={4}
                    />
                  </div>

                  <div className="col-12 col-md-12 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Message
                    </label>
                    <textarea
                      required
                      className="form-control radius-8"
                      placeholder="Enter mail message"
                      value={sendMailForm.message}
                      onChange={(e) =>
                        setSendMailForm({
                          ...sendMailForm,
                          message: e.target.value,
                        })
                      }
                      rows={4}
                    />
                  </div>

                  {/* Email Template Select */}

                  {/* Submit Button */}
                  <div className="d-flex align-items-center justify-content-start gap-3 mt-12">
                    <button
                      type="submit"
                      disabled={sendingEmail}
                      className="btn btn-primary border border-primary-600 text-md px-48 py-12 radius-8"
                    >
                      {sendingEmail ? "Sending..." : "Send"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModalEdit"
        tabIndex={-1}
        aria-labelledby="exampleModalEditLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content radius-16 bg-base">
            <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
              <h1 className="modal-title fs-5" id="exampleModalEditLabel">
                Confirm Deletion
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body p-24 text-center">
              <p className="mb-4 fs-6 text-secondary">
                Are you sure you want to delete this item?
              </p>
              <div className="d-flex justify-content-center gap-3 mt-3">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleConfirmDelete}
                >
                  Confirm
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CustomersTable